var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.translationLink.uri)?_c('div',{staticClass:"hiq-menu__container hiq-menu__container--translations"},[_c('a',{staticClass:"hiq-menu__link hiq-menu__link--translation",attrs:{"href":_vm.translationLink.uri || '#'}},[_vm._v(" "+_vm._s(_vm.translationLink.name)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }